module.exports = __webpack_public_path__ + "img/mile5.724897fb.webp";